<template>
  <div class="ts-overflow-scroll ts-max-h-screen">
    <form action="">
      <fieldset>
        <legend>{{ $t('thesis.studentList') }}</legend>
        <ts-table :columns="columns" :records="thesis_registration_members">
          <template v-slot="{ record, index }">
            <td style="vertical-align: middle" class="ts-text-center">
              {{ index + 1 }}
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              <span v-if="record.is_leader == 1" class="text-primary">Yes</span>
              <span v-else class="text-danger">No</span>
            </td>
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.card_number ? record.card_number : null }}
            </td>

            <td style="vertical-align: middle">
              <b class="ts-text-blue-600">{{ record.full_name_en }}</b>
            </td>
            <td style="vertical-align: middle">
              {{ record.gender }}
            </td>
            <td style="vertical-align: middle">
              {{ record.acps_name_foreign }}
            </td>
          
            <td style="vertical-align: middle" class="ts-text-center">
              {{ record.promotion }}
            </td>
          </template>
        </ts-table>
      </fieldset>
    </form>
  </div>
</template>
<script>
export default {
  name: 'viewStudentList',
  props: ['thesis_registration_members'],
  data () {
    return {
      photoError: require('../../../assets/user_default.png')
    }
  },
  computed: {
    columns () {
      return [
        {
          name: this.$t('thesis.no'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.leader'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.cardNumber'),
          style: 'text-align:center'
        },
        {
          name: this.$t('thesis.studentName'),
          sortKey: 'full_name_en'
        },
        {
          name: this.$t('thesis.sex')
        },
        {
          name: this.$t('thesis.major')
        },
        
        {
          name: this.$t('thesis.promotion'),
          style: 'text-align:center'
        }
      ]
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table thead tr th {
  text-transform: uppercase;
  padding: 4px 7px;
  background: rgb(218, 218, 218);
}
table tbody tr td {
  padding: 4px 7px;
}
</style>
